import { render } from "./Primalevaview.vue?vue&type=template&id=73c8c213"
import script from "./Primalevaview.vue?vue&type=script&lang=js"
export * from "./Primalevaview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__